import { AcquireBookStatusPresenter } from "./presenter";

export const AcquireBookStatusContainer: React.FC = () => {
  return <AcquireBookStatusPresenter />;
};
